
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

const SUPABASE_URL = "https://uejqdykcumyfoqpzcbcg.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVlanFkeWtjdW15Zm9xcHpjYmNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkwNTUzODUsImV4cCI6MjA1NDYzMTM4NX0.STrYBf_abEhas2IZYU3RPdG94sklXiCfRoLFJknVlYQ";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined
    },
    global: {
      headers: {
        'Cache-Control': 'no-store'
      }
    }
  }
);

// Initialize auth state from URL if available
if (typeof window !== 'undefined') {
  // Get initial session
  supabase.auth.getSession().then(({ data: { session } }) => {
    if (session) {
      console.log('Session initialized');
    } else {
      console.log('No active session found');
    }
  });

  // Set up auth state listener
  supabase.auth.onAuthStateChange((event, session) => {
    console.log('Auth state changed:', event);
    if (event === 'SIGNED_OUT') {
      // Clear any auth-related state
      console.log('User signed out');
      localStorage.removeItem('supabase.auth.token');
      window.location.href = '/';
    } else if (event === 'SIGNED_IN') {
      console.log('User signed in');
    }
  });
}

// Helper function to check if session is valid
export const getValidSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) {
    console.error('Session error:', error);
    return null;
  }
  return session;
};

// Helper function to check if user is creator
export const isCreator = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('creator_status')
      .eq('id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error checking creator status:', error);
      return false;
    }

    return data?.creator_status === 'creator';
  } catch (error) {
    console.error('Error in isCreator check:', error);
    return false;
  }
};
